<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<!-- Encabezado de la sección de grupos con filtro y acción principal -->
			<div class="units-header-panel">
				<!-- Fila principal -->
				<div class="units-header-row units-header-row-main">
					<!-- Título -->
					<div class="units-header-left">
						<span class="units-title">
							<i class="fa fa-image"></i>
							Lista de Unidades
						</span>
					</div>

					<!-- Filtro -->
					<div class="units-header-right" *ngIf="isAdmin">
						<div class="units-filter-block units-filter-dropdown">
							<p-dropdown
								[options]="clientes"
								optionLabel="name"
								optionValue="id"
								[(ngModel)]="selectedClientId"
								(ngModelChange)="onClientChange()"
								styleClass="filter-dropdown"
								[filter]="true"
								placeholder="Selecciona un partner"
							></p-dropdown>
						</div>

						<button
							*ngIf="selectedClientId"
							type="button"
							class="btn btn-outline-secondary btn_clean action-btn"
							(click)="clearClientFilter()"
							title="Quitar filtro"
						>
							<i class="fa fa-times"></i>
						</button>
					</div>
					<!-- Fila de acciones -->
					<div class="" *ngIf="canAddGroup">
						<div class="units-actions-group">
							<button
								class="btn btn-primary action-btn"
								(click)="add()"
							>
								<i class="fa fa-plus-square"></i>
								Agregar Grupo
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="card-body">
				<app-datatable [options]="dtConfig"></app-datatable>
			</div>
		</div>
	</div>
</div>
